<template>
    <div class="row">
        <div class="col-12">
            <card :title="table1.title" :subTitle="table1.subTitle">
                <div slot="raw-content" class="table-responsive">
                    <paper-table :data="table1.data" :columns="table1.columns">
                        <div class="text-center" v-if="loader1">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden"></span>
                            </div>
                        </div>
                        <table border="4" width="100%" style="border:4px;">
                            <tr>
                                <th>Data</th>
                                <th>Tarifa</th>
                                <th>Pagesat</th>
                                <th>Shenime</th>
                            </tr>
                            <tr v-for="item in pagesat" v-bind="item.key">
                                <td> {{ item.data }}</td>
                                <td> {{ item.tarifa }} </td>
                                <td> {{ item.vlera }} </td>
                                <td> {{ item.shenime }} </td>
                            </tr>
                            <tr>
                                <td><b>Totali:</b> </td>
                                <td>{{ this.totali_pagesat.tarifa }}</td>
                                <td>{{ this.totali_pagesat.pagesat }}</td>
                                <td></td>
                            </tr>
                        </table>
                    </paper-table>
                    <h5 class="p-2 bold">
                        <div class="text-center" v-if="loader2">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden"></span>
                            </div>
                        </div>
                        <strong> Totali për pagesë: {{ this.totali_pagesat.per_pagese.toFixed(2) }} </strong>
                    </h5>
                </div>
            </card>
        </div>
    </div>
</template>

<script>

import { PaperTable } from "@/components";
import { runInThisContext } from "vm";
import { APISettings } from '../api/config.js'

const tableColumns = [];
const tableData = [{
    data: "",
    tarifa: "",
    pagesat: "",
    shenime: "",
    loader1: false,
    loader2: false,
},
];

export default {
    components: {
        PaperTable,
    },
    data()
    {
        return {
            table1: {
                columns: [...tableColumns],
                data: [...tableData],
                totali: "1200",
            },
            pagesat: [],
            loader1: false,
            loader2: false,
            tarifa: "",
            totali_pagesat: [],
        };
    },

    methods: {
        getData()
        {
            this.loader1 = true;
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Pagesat/getGjendja/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + get_token
                },
            })
                .then(
                    (signinResponse) =>
                    {

                        signinResponse.json().then((res) =>
                        {
                            if (signinResponse.status === 200)
                            {
                                res.forEach((obj) =>
                                {
                                    this.pagesat = res;
                                });
                            } else if (signinResponse.status === 400)
                            {
                                console.log("ERROR DATA1");
                            }
                            this.loader1 = false;
                        })
                    }).catch(error =>
                    {
                        console.log("ERROR DATA2");
                    })
        },

        getTotali()
        {
            this.loader2 = true;
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Pagesat/getTotalPagesat/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + get_token
                },
            })
                .then(
                    (signinResponse) =>
                    {

                        signinResponse.json().then((res) =>
                        {
                            if (signinResponse.status === 200)
                            {
                                res.forEach((obj) =>
                                {
                                    this.totali_pagesat = obj;
                                });

                            } else if (signinResponse.status === 400)
                            {
                                console.log("ERROR DATA1");
                            }
                            this.loader2 = false;
                        })
                    }).catch(error =>
                    {
                        console.log("ERROR DATA2");
                    })
        }

    },

    beforeMount()
    {
        this.getData();
        this.getTotali();
    },
};

</script>

<style></style>
